module.exports = __webpack_public_path__ + "static/media/unilever.0a0ae9ff.png";